module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-lb-tabs-item', {
    class: [_vm.chosenPeriod === _vm.tabKey ? 'ark-active' : '', 'ark-leaderboard-tabs-item'],
    attrs: {
      "ark-test-id": _vm.testId
    },
    on: {
      "click": _vm.onChoseTab
    }
  }, [_vm._v("\n  " + _vm._s(_vm.tabName) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e42678b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabsItem/TabsItem.vue
// module id = 15
// module chunks = 0